<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 22L21.7197 2.06259M2.24313 2C2.24313 2 14.569 14.4622 22 21.9753L2.24313 2Z" stroke="#747272" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

</template>

<script>
    export default {
        name: "Close"
    }
</script>

<style scoped>

</style>